export default __webpack_public_path__ + "static/media/thumbs-up-icon.e9599829.svg";